/**
 * Created by hp on 2017/6/12.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

import {renderMoney} from '../../utils';

class LecturePaySingleChannelPanel extends Component {
    constructor() {
        super();
        this.onSelectSingle = this.onSelectSingle.bind(this);
    }

    onSelectSingle() {
        this.props.dispatch({
            type: 'LECTURE_SET_SINGLE_CHANNEL_PAY'
        });
    }

    render() {
        const {channel, isSelectSingleChannel} = this.props;
        const limitPrice = channel && channel.promoprice
        let isChannelCostFix = channel && channel.is_cost_fix;
        return (
            <div className="weui-actionsheet__cell weui-padding wk-border-line-bottom " onClick={this.onSelectSingle}>
                <p className="weui-flex">
                    {isChannelCostFix &&
                    <i className={"iconfont icon-zhengque " + (isSelectSingleChannel ? "select" : 'no-select')}/>
                    }
                    <span className="weui-flex__item text-left flex_3">
                        <span className="padding-left">购买专栏（已更新{channel.channel_lecture_count}节课）</span>
                    </span>
                    <span className="weui-flex__item text-right flex_2">
                        {isChannelCostFix &&
                        <span className="key-num fr">
                            <span>￥{renderMoney(limitPrice ? limitPrice.price : channel.money)} </span>
                            {(channel.all_lecture_money - channel.money > 0) &&
                            <span className="origin-money">￥{renderMoney(channel.all_lecture_money)}</span>
                            }
                        </span>
                        }
                    </span>
                </p>
            </div>
        )
    }
}

export default connect((state) => ({
    channel: state.lecture.channel,
    isSelectSingleChannel: state.lecture.isSelectSingleChannel
}))(LecturePaySingleChannelPanel);


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePaySingleChannelPanel.js